import "./customerdisplay.scss";
import { type FC } from "react";
import { type ComponentDifference } from "../../Routes/SellScreen/Transaction/ProductLineComponents";
import {
    type BaseComponentSettings,
    type CustomerDisplayComponentType,
} from "../../Routes/Settings/CustomerDisplay/CustomerDisplayTypes";
import { GridPosition } from "../Forms/GridEditor/GridPosition";
import ShopfrontLogo from "../Misc/ShopfrontLogo";
import { CustomerDisplayComponent } from "./CustomerDisplayComponent";

export interface CustomerDisplayItemData {
    item: string;
    quantity: number;
    price: string;
    totalPrice: string;
    promotion: boolean;
    isCase: boolean;
    components: Array<ComponentDifference>;
}

export interface CustomerDisplayTotalData {
    total: string;
    savings: number;
    cashout: number;
    change: number;
    surcharge: number;
    remaining: number;
    paid: number;
}

export interface CustomerDisplayData {
    totals: CustomerDisplayTotalData;
    eftpos: boolean;
    text: {
        itemCount: number;
    };
    sale: Array<CustomerDisplayItemData>;
}

interface Props {
    data: CustomerDisplayData;
    format: Array<CustomerDisplayComponentType>;
    done: boolean;
    fullscreen?: boolean;
}

export interface CustomerDisplayComponentProps<
    TSettings extends BaseComponentSettings,
    TData extends null | CustomerDisplayTotal | CustomerDisplayProductData
> {
    settings: TSettings;
    data: TData;
}

export interface CustomerDisplayTotal {
    total: false | string;
    savings: false | string;
    change: false | string;
    approved: boolean;
    thanks: boolean;
    remaining: false | string;
    paid: false | string;
}

export interface CustomerDisplayProductData {
    products: CustomerDisplayData["sale"];
    surcharge: number;
}

const CustomerDisplay: FC<Props> = ({
    data,
    format,
    done,
    fullscreen,
}) => {
    const classes = [ "customer-display" ];

    if(fullscreen) {
        classes.push("fullscreen");
    }

    return (
        <div className={classes.join(" ")}>
            {format.map(({ position, ...component }, index) => (
                <GridPosition
                    key={component.type + "|" + index}
                    top={position.top}
                    left={position.left}
                    width={position.width}
                    height={position.height}
                >
                    <CustomerDisplayComponent
                        data={data}
                        done={done}
                        component={component}
                    />
                </GridPosition>
            ))}
            {(!format.length) && (
                <div className="customer-display-empty-wrapper">
                    <div className="customer-display-empty">
                        <ShopfrontLogo />
                        <p>Customer display not set up.</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CustomerDisplay;
